export const numberFormat = (value) => {
  const formattedValue =
    Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value) ?? 0;

  return formattedValue;
};

export const philippineCurrency = (value) => {
  const formattedPHP = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'PHP',
  }).format(value);

  return formattedPHP;
};

export const maskAmount = (value) => {
  return value.replace(/\d/g, 'X');
};

export const percentageColor = (value) => {
  let fontColor;

  if (parseFloat(value) >= 120) {
    fontColor = '#1F4D10';
  }

  if (parseFloat(value) >= 100 && parseFloat(value) <= 119) {
    fontColor = '#557c55';
  }

  if (parseFloat(value) >= 90 && parseFloat(value) <= 99.99) {
    fontColor = '#65B741';
  }

  if (parseFloat(value) >= 80 && parseFloat(value) <= 89.99) {
    fontColor = '#ffff00';
  }

  if (parseFloat(value) >= 50 && parseFloat(value) <= 79.99) {
    fontColor = '#ff0000';
  }

  if (parseFloat(value) < 50) {
    fontColor = '#720000';
  }

  if (parseFloat(value) === null || parseFloat(value) === undefined) {
    fontColor = '#e6e6e6';
  }

  return fontColor;
};

export const filterValue = (form) => {
  const formValue = form?.value;
  const filterFormValue = formValue !== null ? [formValue] : [];

  return filterFormValue;
};
